import CardTable from "./templateInspo/CardTable.vue";
import TemplateCard from "./templateInspo/TemplateCard.vue";
import CreatorFree from "./templateInspo/CreatorFree.vue";
import { mapState } from "vuex";
import { setMeta } from "./js/meta";
import { jumpComDashboard, jumpComSignUp } from "@/utils/host";
export default {
  components: {
    CardTable,
    TemplateCard,
    CreatorFree
  },
  props: {
    isMobile: Boolean
  },
  mixins: [require("@/router/ssr_mixin")],
  data() {
    return {
      title: "20 Best link in bio page template examples 2022-2023 | linkr.com",
      description: "Linkr: we reviewed 1000 link in bio examples of our creators. Here are the top 20 most popular and best-practiced instagram link in bio template that inspire everyone!",
      templateList: [{
        title: "inspocard_business_title",
        type: "business",
        info: "inspocard_business_info",
        subTitle: "inspocard_business_subtitle",
        subList: ["inspocard_business_list1", "WhatsApp_link", "inspocard_business_list3", "inspocard_business_list4", "inspocard_business_list5", "inspocard_business_list6", "inspocard_business_list7"],
        subTip: "inspocard_business_subtip",
        swipes: [{
          src: "https://linkr.bio/joseysandra",
          page: "joseysandra",
          pic: "inspo_business1.png",
          isPro: true,
          alt: "Best Linkr bio link page design examples: for e-commerce businesses and entrepreneurs bio link with a youtube video and website link"
        }, {
          src: "https://linkr.bio/maxicredi.emprestimos",
          page: "maxicredi.emprestimos",
          pic: "inspo_business2.png",
          isPro: true,
          alt: "Linkr.bio real user's bio page design example: for food and restaurant online businesses bio link template with a youtube video and website link"
        }, {
          src: "https://linkr.bio/copernico Business",
          page: "copernico Business",
          pic: "inspo_business3.png",
          isPro: true,
          alt: "Linkr.bio real user's link in bio page design example: bio link template for Columbia logistic business  with a youtube video, website link, and contact information"
        }, {
          src: " https://linkr.bio/mamutproducciones",
          page: "mamutproducciones",
          pic: "inspo_business4.png",
          isPro: true,
          alt: "Linkr.bio real user's link in bio page design example: e-commerce business online shop bio link best practice template shop items displayed on bio template and with icon links to Instagram, TikTok, and youtube."
        }, {
          src: "https://linkr.bio/lolsurprise",
          page: "lolsurprise",
          pic: "inspo_business5.png",
          isPro: false,
          alt: "Linkr.bio foody and restaurant user's link in bio page example: online dessert shop with cake for sale and receipt displayed on link in bio page"
        }, {
          src: "https://linkr.bio/laura.foodfamily",
          page: "laura.foodfamily",
          pic: "inspo_business6.png",
          isPro: true,
          alt: "Best bio link example for local business: Linkr.bio real user's link in bio page for real estate, displaying best selling properties and organization's social media links."
        }]
      }, {
        title: "inspocard_video_title",
        type: "video",
        info: "inspocard_video_info",
        subTitle: "inspocard_video_subtitle",
        subList: ["inspocard_business_list1", "inspocard_video_list2"],
        subTip: "inspocard_video_subtip",
        swipes: [{
          src: "https://linkr.bio/Irfanpradana",
          page: "Irfanpradana",
          pic: "inspo_video1.png",
          isPro: true,
          alt: "Linkr.bio real user's link in bio page design example: bio link template for video creator with a youtube video, art design display feature panel"
        }, {
          src: "https://linkr.bio/pitchside",
          page: "pitchside",
          pic: "inspo_video2.png",
          isPro: true,
          alt: "Best Linkr bio link example for video creators: youtube video embedding with social media icons on bio link for Twitter, Facebook, Instagram, Spotify, and TikTok."
        }, {
          src: "https://linkr.bio/rspro",
          page: "rspro",
          pic: "inspo_video3.png",
          isPro: true,
          alt: "Linkr.bio real user's link in bio page design example: bio link template for social influencer video creator with social media icons on bio link for TikTok, Instagram, Youtube, telegram, Spotify, and email."
        }]
      }, {
        title: "inspocard_artists_title",
        type: "artists",
        info: "inspocard_artists_info",
        swipes: [{
          src: "https://linkr.bio/clau.kv/ Artist",
          page: " Artist",
          pic: "inspo_artists1.png",
          isPro: true,
          alt: "Linkr.bio real user's link in bio page design example: bio link template for visual artists creator with a youtube video, links to social icons, Patreon integration and support me money receiving function"
        }, {
          src: "https://linkr.bio/Eugene_art_studioArtist",
          page: "Eugene_art_studioArtist",
          pic: "inspo_artists2.png",
          isPro: true,
          alt: "Linkr.bio real user's link in bio page design example: bio link template for a freelance illustrator with links to social icons, TipJar platform money receiving integration"
        }, {
          src: "https://linkr.bio/ettoreriva",
          page: "ettoreriva",
          pic: "inspo_artists3.png",
          isPro: true,
          alt: "Linkr.bio real user's link in bio page design example: bio link template for a french photographer with his contact info links and social bio links"
        }]
      }, {
        title: "inspocard_musicians_title",
        type: "musicians",
        info: "inspocard_musicians_info",
        subTitle: "inspocard_musicians_subtitle",
        subList: ["inspocard_musicians_list1", "inspocard_musicians_list2", "inspocard_musicians_list3", "inspocard_musicians_list4"],
        swipes: [{
          src: "https://linkr.bio/djbens",
          page: " djbens",
          pic: "inspo_musicians1.png",
          isPro: true,
          alt: "Best Linkr bio link example for musicians: music links and playlist integrated with Spotify, video embedding with Youtube, Vimeo, and TikTok, and social media icons on bio link for Twitter, Facebook, and Instagram."
        }, {
          src: "https://linkr.bio/martinefarstad",
          page: "martinefarstad",
          pic: "inspo_musicians2.png",
          isPro: true,
          alt: "Best Linkr bio link example for musicians: a beautiful female internet celebrity singer on Instagram and her bio page on."
        }, {
          src: "https://linkr.bio/rammstein",
          page: "rammstein",
          pic: "inspo_musicians3.png",
          isPro: true,
          alt: "Linkr.bio real user's bio link example for musicians: a pop musician's bio page example and his music album released on YouTube and Spotify displayed on his bio link page."
        }, {
          src: "https://linkr.bio/Felixir_",
          page: " Felixir_",
          pic: "inspo_musicians4.png",
          isPro: false,
          alt: "Linkr.bio real user's bio link example for musicians: showing integrated icons for SoundCloud and Bandcamp, Tumblr, and music links and works on the bio link page."
        }, {
          src: "https://linkr.bio/bragapratama",
          page: "bragapratama",
          pic: "inspo_musicians5.png",
          isPro: false,
          alt: "Best bio link practice example: a music lover's bio page template showing her favorite music album cover and music links to YouTube, Spotify, and SoundCloud."
        }, {
          src: "https://linkr.bio/djkaoru",
          page: "djkaoru",
          pic: "inspo_musicians6.png",
          isPro: true,
          alt: "Best bio link practice example: a Brazilian and Japanese electrical music lover's bio page template showing his favorite music albums and music links to Spotify and SoundCloud."
        }]
      }, {
        title: "inspocard_gaming_title",
        type: "gaming",
        info: "inspocard_gaming_info",
        subTitle: "inspocard_gaming_subtitle",
        subList: ["inspocard_gaming_list1", "inspocard_gaming_list2", "WhatsApp_link", "inspocard_gaming_list4", "inspocard_gaming_list5"],
        swipes: [{
          src: "https://linkr.bio/hechwiz",
          page: "hechwiz",
          pic: "inspo_gaming1.png",
          isPro: false,
          alt: "Linkr.bio real user's bio link example for gaming creators: a twitch gaming broadcaster's bio link page example with linkr.bio"
        }, {
          src: "https://linkr.bio/satty",
          page: "satty",
          pic: "inspo_gaming2.png",
          isPro: false,
          alt: "Linkr.bio real user's bio link best practice for cosplay creators: a female cosplay enthusiastic social creator's bio link page example displaying her best cosplay work and links to Instagram, Twitter, and Facebook"
        }, {
          src: "https://linkr.bio/EYEFORTECH",
          page: "EYEFORTECH",
          pic: "inspo_gaming3.png",
          isPro: false,
          alt: "Best bio link practice example for tech creators: a dark theme linkr.bio template applied by a tech influencer adding his social links on the bio page."
        }]
      }, {
        title: "inspocard_sensitive_title",
        type: "sensitive",
        info: "inspocard_sensitive_info",
        subTitle: "inspocard_sensitive_subtitle",
        subList: ["inspocard_sensitive_list1", "inspocard_sensitive_list2", "inspocard_sensitive_list3", "inspocard_sensitive_list4", "WhatsApp_link", "inspocard_sensitive_list6", "inspocard_sensitive_list7"],
        swipes: [{
          src: "https://linkr.bio/Karlasofiarey",
          page: "Karlasofiarey",
          pic: "inspo_sensitive1.png",
          isPro: true,
          alt: "Best bio link example design practice for sensitive content creators like onlyfans, fansly, and adult site"
        }, {
          src: "https://linkr.bio/danielboom",
          page: "danielboom",
          pic: "inspo_sensitive2.png",
          isPro: false,
          alt: "Bio link example design best practice template with unlimited social links"
        }, {
          src: "https://linkr.bio/Setteamoure",
          page: "Setteamoure",
          pic: "inspo_sensitive3.png",
          isPro: true,
          alt: "Bio link example designs best practice template with video thumbnail cover embedded on the bio page."
        }]
      }]
    };
  },
  computed: {
    ...mapState("user", ["isLogin"]),
    targetList() {
      return this.templateList.map(item => {
        return {
          name: item.type,
          jumpTo: ".template-card-" + item.type
        };
      });
    }
  },
  created() {
    setMeta("twitter:title", this.title, false);
    setMeta("twitter:description", this.description, false);
    setMeta("og:title", this.title, true);
    setMeta("og:description", this.description, true);
  },
  methods: {
    // 免费注册
    signUpFreeFun() {
      if (this.isLogin) {
        jumpComDashboard();
      } else {
        jumpComSignUp(location.origin);
      }
    }
  }
};